var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "notice-content" }, [
        _c("p", { staticClass: "title" }, [_vm._v("打印指导")]),
        _vm._v(" "),
        _c("div", [
          _c("p", [_vm._v("类型：箱码标签打印")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "说明：箱码标签，更新打印方式（由print服务打印改为浏览器打印），不再需要启动print服务，直接通过浏览器打印即可。"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", { staticClass: "blue blod" }, [_vm._v("*属性信息")]),
          _vm._v(" "),
          _c("p", [_vm._v("打印机机型：Gprinter GP-1924D")]),
          _vm._v(" "),
          _c("p", [_vm._v("打印尺寸：80*50mm")])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", { staticClass: "blue blod" }, [_vm._v("*打印设置（必设）")]),
          _vm._v(" "),
          _c("p", { staticClass: "blue blod" }, [_vm._v("1.浏览器")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("推荐：chorme浏览器  "),
            _c(
              "a",
              {
                staticClass: "blue",
                attrs: {
                  href: "https://www.google.cn/chrome/thank-you.html",
                  target: "_blank"
                }
              },
              [_vm._v("下载地址")]
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("不支持：火狐浏览器等")])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("p", { staticClass: "blue blod" }, [_vm._v("2.浏览器打印设置")]),
          _vm._v(" "),
          _c("p", [_vm._v("必设项：目标打印机、布局、纸张尺寸、边距。")])
        ]),
        _vm._v(" "),
        _c("div", [_c("p", [_vm._v("示例如图")])])
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { "text-align": "center" } }, [
        _c("img", {
          attrs: {
            src: require("./../../assets/img/printNotice1.png"),
            alt: "",
            width: "95%"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "margin-top": "20px" } },
        [
          _c("img", {
            attrs: {
              src: require("./../../assets/img/printNotice.png"),
              alt: "",
              width: "95%"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "30px", "margin-right": "40px" } },
        [
          _c(
            "p",
            {
              staticStyle: {
                "text-align": "right",
                "font-weight": "600",
                "font-size": "16px"
              }
            },
            [_vm._v("2019年9月5日")]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-550db5b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-550db5b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/notice/printNotice.vue
// module id = null
// module chunks = 